export default function handleFlaggedPost(params) {
  const tenantNameRaw = params.get("tenantName") || "";
  const tenantId = params.get("tenantId");
  const emailIdRaw = params.get("emailId") || "";

  let tenantName = "";
  let emailId = "";

  try {
    tenantName = tenantNameRaw
      ? decodeURIComponent(atob(tenantNameRaw))
      : "";
  } catch (error) {
    tenantName = tenantNameRaw;
  }

  try {
    emailId = emailIdRaw
      ? decodeURIComponent(atob(emailIdRaw))
      : "";
  } catch (error) {
    emailId = "";
  }

  return {
    action: "flaggedPost",
    tenantId: tenantId ? Number(tenantId) : null,
    tenantName,
    emailId,
  };
}